module.exports = __webpack_public_path__ + "static/media/resort.70f8a02a.jpg";